"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedNodeExtension = void 0;
const core_1 = require("@remirror/core");
const Extensions_1 = require("../Extensions");
const CollapseBox_1 = __importDefault(require("../../ui/CollapseBox/CollapseBox"));
let UnsupportedNodeExtension = class UnsupportedNodeExtension extends core_1.NodeExtension {
    get name() {
        return Extensions_1.NodeName.Unsupported;
    }
    ReactComponent = CollapseBox_1.default;
    createTags() {
        return [core_1.ExtensionTag.InlineNode];
    }
    createNodeSpec(extra, override) {
        return {
            selectable: false,
            draggable: false,
            atom: true,
            inline: true,
            ...override,
            attrs: {
                ...extra.defaults(),
                originalNode: {},
                errorMessage: {},
            },
            parseDOM: [
                {
                    tag: `[data-unsupported-node]`,
                    getAttrs: (node) => {
                        if (!(0, core_1.isElementDomNode)(node)) {
                            return false;
                        }
                        const unsupportedNodes = node.getAttribute('data-unsupported-node');
                        try {
                            const decodedNodes = JSON.parse(unsupportedNodes);
                            return {
                                ...extra.parse(node),
                                originalNode: decodedNodes?.originalNode,
                                errorMessage: decodedNodes?.errorMessage,
                            };
                        }
                        catch (error) {
                            console.error('Failed to parse Remirror nodes from data-unsupported-node', error);
                            return false;
                        }
                    },
                },
            ],
            toDOM: (node) => {
                const { originalNode, errorMessage, ...rest } = (0, core_1.omitExtraAttributes)(node.attrs, extra);
                const attrs = {
                    ...extra.dom(node),
                    ...rest,
                    originalNode,
                    errorMessage,
                    'data-unsupported-node': JSON.stringify({ originalNode, errorMessage }),
                };
                return ['div', attrs];
            },
        };
    }
};
UnsupportedNodeExtension = __decorate([
    (0, core_1.extension)({})
], UnsupportedNodeExtension);
exports.UnsupportedNodeExtension = UnsupportedNodeExtension;
